import { ComponentProps, ReactNode } from 'react';
import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import {
  NavItem as FluentNavItem,
  NavSubItem as FluentNavSubItem,
  NavCategoryItem as FluentNavCategoryItem,
} from '@fluentui/react-nav-preview';
import { TIcon } from '@shared/types';
import classNames from 'classnames';

const useStyles = makeStyles({
  root: {
    backgroundColor: 'transparent',

    // similar to the OneDrive design & our Breadcrumbs
    '&:hover': {
      backgroundColor: `${tokens.colorNeutralBackground3Hover}`,
      color: `${tokens.colorNeutralForeground2Hover}`,
    },
    '&:active': {
      backgroundColor: `${tokens.colorNeutralBackground3Pressed}`,
      // color: `${tokens.colorNeutralForeground2Pressed}`,
    },
  },
  medium: {
    fontSize: '15px',
  },
  small: {
    fontSize: '14px',
    // paddingTop: '7px',
    // paddingBottom: '7px',
  },
});

type TNavItem = {
  children: ReactNode;
  value: string;
  icon?: TIcon;
  size?: 'small' | 'medium';
  disabled?: boolean;
  onClick?: ComponentProps<'button'>['onClick'];
};
const NavItem = ({ children, value, icon, size = 'medium', disabled = false, onClick }: TNavItem) => {
  const classes = useStyles();

  return (
    <FluentNavItem
      value={value}
      icon={icon}
      className={mergeClasses(classes.root, size === 'medium' ? classes.medium : classes.small)}
      disabled={disabled}
      onClick={onClick}
    >
      <span className={classNames({ 'pl-2': !icon }, 'w-full')}>{children}</span>
    </FluentNavItem>
  );
};

const NavSubItem = ({ children, value, icon, size = 'medium', disabled = false }: TNavItem) => {
  const classes = useStyles();

  return (
    <FluentNavSubItem
      value={value}
      className={mergeClasses(classes.root, size === 'medium' ? classes.medium : classes.small)}
      disabled={disabled}
    >
      {children}
    </FluentNavSubItem>
  );
};

const NavCategoryItem = ({ children, value, icon, disabled = false }: TNavItem) => {
  const classes = useStyles();

  return (
    <FluentNavCategoryItem value={value} icon={icon} disabled={disabled} className={classes.root}>
      <span className={classNames({ 'pl-2': !icon })}>{children}</span>
    </FluentNavCategoryItem>
  );
};

export { NavItem, NavSubItem, NavCategoryItem };
